import { useLocation } from "react-router-dom";

/** Paths for Finance list/detail screens (sales vs legacy short paths). */
export function useFinanceInvoicePaths() {
  const { pathname } = useLocation();
  const salesInvoices =
    pathname.startsWith("/finance/sales/invoices") || pathname === "/finance/sales/invoices";
  const salesContext = pathname.startsWith("/finance/sales/");

  return {
    salesInvoices,
    listPath: salesInvoices || salesContext ? "/finance/sales/invoices" : "/finance/invoices",
    newPath: salesInvoices || salesContext ? "/finance/sales/invoices/new" : "/finance/invoices/new",
    detailPath: (id: string) =>
      salesInvoices || salesContext
        ? `/finance/sales/invoices/${encodeURIComponent(id)}`
        : `/finance/invoices/${encodeURIComponent(id)}`,
    accountsPath: "/finance/sales/accounts",
    paymentsPath: "/finance/sales/payments-received",
  };
}

export function useFinanceAccountPaths() {
  const { pathname } = useLocation();
  const salesAccounts =
    pathname.startsWith("/finance/sales/accounts") || pathname === "/finance/sales/accounts";

  return {
    salesAccounts,
    listPath: salesAccounts ? "/finance/sales/accounts" : "/finance/customers",
    detailPath: (id: string) =>
      salesAccounts
        ? `/finance/sales/accounts/${encodeURIComponent(id)}`
        : `/finance/customers/${encodeURIComponent(id)}`,
    listLabel: salesAccounts ? "All accounts" : "All customers",
    entityLabel: salesAccounts ? "account" : "customer",
  };
}
